import React from "react";
import Header from "../../components/header";
import bannerImageOne from "../../images/savings-banner-image-one.jpg";
import bannerImageTwo from "../../images/savings-banner-image-two.jpg";
import bannerImageThree from "../../images/saings-banner-image-three.jpg";

const raleway = { fontFamily: "'Geist', sans-serif" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const SavingsMain = () => {
  return (
    <>
      <style>{`
				.savings-hero-image { width: 100%; height: 100%; object-fit: cover; display: block; }
				@media (max-width: 900px) {
					.savings-hero-row { flex-direction: column !important; gap: 32px !important; }
					.savings-hero-images { width: 100% !important; }
					.savings-hero-text { width: 100% !important; }
					.savings-hero-big-image-wrap { min-height: 260px !important; height: 260px !important; }
					.savings-hero-small-image-wrap { min-height: 120px !important; height: 120px !important; }
				}
				@media (max-width: 480px) {
					.savings-hero-big-image-wrap { min-height: 220px !important; height: 220px !important; }
					.savings-hero-small-image-wrap { min-height: 105px !important; height: 105px !important; }
				}
			`}</style>

      <Header />

      <section
        style={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          boxSizing: "border-box",
          padding:
            "clamp(32px, 5.56vw, 80px) clamp(20px, 5.56vw, 80px) clamp(48px, 6.94vw, 100px)",
        }}
      >
        <div
          className="savings-hero-row"
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            display: "flex",
            gap: "clamp(24px, 4.17vw, 60px)",
            alignItems: "stretch",
          }}
        >
          {/* Left text + CTAs */}
          <div
            className="savings-hero-text"
            style={{
              flex: "1 1 0",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "clamp(20px, 1.94vw, 28px)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#66A681",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.08em",
                  color: "#295B4A",
                  textTransform: "uppercase",
                }}
              >
                Savings &amp; Fixed Deposit
              </span>
            </div>

            <h1
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(38px, 6.25vw, 84px)",
                lineHeight: 1.02,
                letterSpacing: "-0.015em",
                color: "#132A22",
                margin: 0,
              }}
            >
              Save with confidence.{" "}
              <span
                style={{
                  ...instrumentSerif,
                  fontStyle: "italic",
                  color: "#295B4A",
                }}
              >
                Grow
              </span>{" "}
              with patience.
            </h1>

            <p
              style={{
                ...raleway,
                fontWeight: 400,
                fontSize: "clamp(14px, 1.25vw, 18px)",
                lineHeight: 1.7,
                color: "#3F5445",
                margin: 0,
                maxWidth: "440px",
              }}
            >
              Whether you're saving daily, planning toward a goal, or growing
              long-term funds, Zikora gives you flexible ways to build your
              future.
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                marginTop: "8px",
              }}
            >
              <a
                href="https://zikoramfb.qoreonline.com/onboarding/type"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...raleway,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "52px",
                  padding: "0 24px",
                  backgroundColor: "#7DBE9C",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "clamp(13px, 1.11vw, 16px)",
                  color: "#132A22",
                  textDecoration: "none",
                }}
              >
                Open Account
              </a>
              <a
                href="https://onelink.to/zikora"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...raleway,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "52px",
                  padding: "0 24px",
                  backgroundColor: "transparent",
                  border: "1px solid #D2DEDE",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "clamp(13px, 1.11vw, 16px)",
                  color: "#132A22",
                  textDecoration: "none",
                }}
              >
                Download the App
              </a>
            </div>
          </div>

          {/* Right image collage */}
          <div
            className="savings-hero-images"
            style={{
              flex: "1 1 0",
              minWidth: 0,
              display: "flex",
              gap: "16px",
            }}
          >
            <div
              className="savings-hero-big-image-wrap"
              style={{
                flex: "1 1 0",
                minWidth: 0,
                background: "#EAF1EC",
                borderRadius: "16px",
                overflow: "hidden",
                minHeight: "clamp(420px, 44vw, 590px)",
              }}
            >
              <img
                src={bannerImageOne}
                alt="Customer using the Zikora app"
                className="savings-hero-image"
              />
            </div>

            <div
              style={{
                flex: "1 1 0",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                className="savings-hero-small-image-wrap"
                style={{
                  flex: "1 1 0",
                  background: "#EAF1EC",
                  borderRadius: "16px",
                  overflow: "hidden",
                  minHeight: "clamp(200px, 21vw, 285px)",
                }}
              >
                <img
                  src={bannerImageTwo}
                  alt="Coins stacked on a table"
                  className="savings-hero-image"
                />
              </div>
              <div
                className="savings-hero-small-image-wrap"
                style={{
                  flex: "1 1 0",
                  background: "#EAF1EC",
                  borderRadius: "16px",
                  overflow: "hidden",
                  minHeight: "clamp(200px, 21vw, 285px)",
                }}
              >
                <img
                  src={bannerImageThree}
                  alt="Couple reviewing savings goals together"
                  className="savings-hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SavingsMain;
